export const cdccNumberFormatStrategy = (value: string) => {
  return !!value.match('[A-Z]{2}[0-9]{14}');
};
